<template>
  <div class="card">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <form class="row" v-on:submit.prevent="submit">
        <div class="col-md-3">
          <div class="form-group">
            <div class="form-group">
              <label>
                <label style="color: red; height: 2px;">*</label> مبلغ
                (ریال)</label
              >
              <input
                type="tel"
                class="form-control ltr-input"
                v-model="amount"
                required
                @keyup="(e) => numberFormat(e.target.value, true)"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>
              <label style="color: red; height: 2px;">*</label> شناسه
              واریز</label
            >
            <input
              required
              type="tel"
              class="form-control ltr-input"
              v-mask="'###########'"
              v-model="paymentId"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>
              <label style="color: red; height: 2px;">*</label> تاریخ
              تراکنش</label
            >
            <Datepicker
              simple
              auto-submit
              locale="fa"
              v-model="transactionDate"
              :max="maxDate"
              :locale-config="{
                fa: {
                  displayFormat: 'jYYYY/jMM/jDD',
                  lang: { label: 'شمسی' },
                },
              }"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>
              <label style="color: red; height: 2px;">*</label> تصویر فیش
              واریزی</label
            >
            <div class="input-group file-browser">
              <input
                type="text"
                class="form-control border-left-0 browse-file"
                id="file"
                placeholder="انتخاب کنید"
                readonly=""
                required
              />
              <label class="input-group-btn">
                <span class="btn btn-primary">
                  انتخاب
                  <input
                    type="file"
                    style="display: none;"
                    accept="image/*"
                    @change="setFile"
                  />
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>
              <label style="color: red; height: 2px;">*</label> سازمان</label
            >
            <select required class="form-control mb-3" v-model="orgenizationId">
              <option value="">سازمان خود را انتخاب کنید</option>
              <option
                v-for="(org, index) in orgenizationList"
                :key="index"
                :value="org.orgId"
              >
                <div
                  class="d-flex w-100 flex-1 flex-row justify-content-between"
                >
                  <span> {{ org.companyName }} </span>
                  <span class="mx-2">
                    - {{ numberFormat(org.balance) }} ریال</span
                  >
                </div>
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>توضیحات</label>
            <textarea class="form-control mb-3" v-model="description" />
          </div>
        </div>
        <div
          class="col-md-12 my-3"
          style="display: flex; justify-content: end;"
        >
          <button
            :disabled="
              !file | !amount | !orgenizationId | !transactionDate | !paymentId
            "
            class="btn btn-primary"
            style="width: 300px;"
          >
            ثبت شارژ
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  name: "Create",
  data() {
    return {
      showLoading: false,
      file: "",
      amount: "",
      transactionDate: "",
      orgenizationId: "",
      orgenizationList: [],
      paymentId: "",
      description: "",
      maxDate: moment().format("jYYYY/jMM/jDD"),
    };
  },
  methods: {
    numberFormat(input, isAmount) {
      let value = input.toString().replace(/,/g, "");
      value = new Intl.NumberFormat("en-IR", {
        maximumSignificantDigits: 20,
      }).format(value);
      if (value == "NaN") value = "";

      if (isAmount) this.amount = value;
      else return value;
    },
    async setFile(e) {
      const file = e.target.files[0];
      const finalFile = await this.toBase64(file);
      this.file = finalFile;
      document.getElementById("file").setAttribute("placeholder", file.name);
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getData() {
      this.$api
        .post("Organizations/OrganizationChargeWallet/GetOrganization", {})
        .then(({ data }) => {
          if (data.status) {
            this.orgenizationList = data.result.data;
          }
        });
    },
    submit() {
      this.showLoading = true;
      const postedData = {
        amount: this.amount.replace(/,/gi, ""),
        paymentDate: this.transactionDate,
        orgId: this.orgenizationId,
        refrenceCode: this.paymentId,
        imageFile: this.file,
        description: this.description,
      };
      this.$api
        .post(
          "Organizations/OrganizationChargeWallet/InitialCreditChargeOrganization",
          postedData
        )
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "شارژ  با موفقیت ثبت شد",
            }).then(() => {
              this.$router.push({ name: "organizationCharge.list" });
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
